/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import './CtLEDs.css';
import { Table } from 'react-bootstrap';

function CtData(props) {

    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { code, ct } = props;
    var [LEDs, setLEDs] = useState([]);
    var [htmlCT, setHtmlCT] = useState(<></>);

    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/CTs?idSolarFarm=" + idParque + "&idCT=" + ct + "&variables=lvBreakerOpen,mvBreakerOpen,trfTempWarn,trfTempTrip,trackerCommError,smartloggerCommError,sensorError,upsSupplyFailure,busCouplerCommError,timeStamp", { method: 'GET', credentials: 'include' })
            .then(async (dataCT) => { setLEDs(await dataCT.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/CTs?idSolarFarm=" + idParque + "&idCT=" + ct + "&variables=lvBreakerOpen,mvBreakerOpen,trfTempWarn,trfTempTrip,trackerCommError,smartloggerCommError,sensorError,upsSupplyFailure,busCouplerCommError,timeStamp", { method: 'GET', credentials: 'include' })
                    .then(async (dataCT) => { setLEDs(await dataCT.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number, ct]);

    useEffect(() => {
        if (LEDs.length > 0) {
            var datos = LEDs[0];
            var html =
                <>
                    <Table striped bordered style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th className='text-center'>Fecha lectura</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='text-center'>{datos.timeStamp ? datos.timeStamp : 'No hay datos'}</td>
                            </tr>
                        </tbody>
                    </Table>

                    <Table striped bordered hover style={{ width: 'fit-content' }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Estados</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td><div className={datos.lvBreakerOpen == false ? 'ct-led-inactive' : 'ct-led-active'} /></td><td> LV Breaker Open</td></tr>
                            <tr><td><div className={datos.mvBreakerOpen == false ? 'ct-led-inactive' : 'ct-led-active'} /></td><td> MV Breaker Open</td></tr>
                            <tr><td><div className={datos.trfTempWarn == false ? 'ct-led-inactive' : 'ct-led-active'} /></td><td> Aviso temperatura trafo</td></tr>
                            <tr><td><div className={datos.trfTempTrip == false ? 'ct-led-inactive' : 'ct-led-active'} /></td><td> Trip temperatura trafo</td></tr>
                            <tr><td><div className={datos.trackerCommError == false ? 'ct-led-inactive' : 'ct-led-active'} /></td><td> Comunicación con trackers</td></tr>
                            <tr><td><div className={datos.smartloggerCommError == false ? 'ct-led-inactive' : 'ct-led-active'} /></td><td> Comunicación con Smartlogger</td></tr>
                            <tr><td><div className={datos.sensorError == false ? 'ct-led-inactive' : 'ct-led-active'} /></td><td> Error de sensor</td></tr>
                            <tr><td><div className={datos.upsSupplyFailure == false ? 'ct-led-inactive' : 'ct-led-active'} /></td><td> Funcionamiento de la SAI</td></tr>
                            <tr><td><div className={datos.busCouplerCommError == false ? 'ct-led-inactive' : 'ct-led-active'} /></td><td> Comunicación con acoplador de bus</td></tr>
                        </tbody>
                    </Table>
                </>

            setHtmlCT(html);
        }
    }, [LEDs])

    return (htmlCT);
};

export default CtData;